import { useEffect, useState } from "react";
import {
    getDeepAnalysisDetails,
    updateDeepAnalysis,
} from "../../utils/api";
import {
    Button,
    Card,
    Box,
    Grid,
    TextField,
    CircularProgress,
} from "@mui/material";
import AppMessageModel from "../../components/AppMessageModel";
import { useNavigate } from "react-router-dom";
// import ImageZoom from "../../components/zoomImage";
import { TableComponent } from "../../components/EditableTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function DeepAnalysis() {
    const navigate = useNavigate();
    const path = window.location.pathname;
    const scan_id = path.split("/")[2];
    const sub_scan_id = path.split("/")[3];

    const [scanData, setScanData] = useState(null);
    const [scanFiles, setScanFiles] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isEdit, setIsEdit] = useState(true);

    const [errorMessage, setIsErrorMessage] = useState(false);
    const [isOpenConformationModel, setIsOpenConformationModel] =
        useState(false);

    const [updatedKarnelCount, setUpdatedKernalCount] = useState({});
    const [updatedKarnelWeight, setUpdatedKernalWeight] = useState({});

    const [overallScore, setOverallScore] = useState(0);
    const [updatedOverallScore, setUpdatedOverallScore] = useState(0);

    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [submitType, setSubmitType] = useState("");

    const [inputValue, setInputValue] = useState("");
    const [inputValueForCount, setInputValueForCount] = useState("");
    const [valuesArray, setValuesArray] = useState({});
    const [valuesArrayForCount, setValuesArrayForCount] = useState({});
    const [viewUpdatedValues, setViewUpdatedValues] = useState({
        updatedKarnelCount: 0,
        updatedKarnelCountPercentage: 0,
        updatedKarnelWeight: 0,
        updatedKarnelWeightPercentage: 0
    });


    // --- Helpers ---
    const processSegmentImages = (segment) => {
        if (!segment) return null;
        const { image } = segment;

        if (image) {
            return {
                top: `data:image/jpeg;base64,${image}`
            };
        }
        if (image) return { top: `data:image/jpeg;base64,${image}`, bottom: null };
        return null;
    };

    const handleOkClick = () => {
        const splitValues = inputValue?.split(",").map((v) => v.trim());
        const classes = scanData?.kernel_details?.classes || [];

        if (classes.length < splitValues.length) {
            return alert("Please Enter Less values");
        }

        const mappedValues = classes.reduce((acc, cls, idx) => {
            acc[cls] = splitValues[idx] || 0;
            return acc;
        }, {});
        setValuesArray(mappedValues);
    };

    const handleOkClickForCount = () => {
        const splitValues = inputValueForCount?.split(",").map((v) => v.trim());
        const classes = scanData?.kernel_details?.classes || [];

        if (classes.length < splitValues.length) {
            return alert("Please Enter Less values");
        }

        const mappedValues = classes.reduce((acc, cls, idx) => {
            acc[cls] = splitValues[idx] || 0;
            return acc;
        }, {});
        setValuesArrayForCount(mappedValues);
    };
    // --- API ---
    useEffect(() => {
        const fetchScans = async () => {
            setIsLoading(true);
            try {
                const res = await getDeepAnalysisDetails(scan_id, sub_scan_id);
                const data = res?.data?.data;
                setScanData(data);
                setScanFiles(processSegmentImages(data?.segment_image));
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchScans();
    }, [scan_id, sub_scan_id]);

    // --- Score Calculation ---
    useEffect(() => {
        const deps = scanData?.kernel_details?.quality_score_dependencies || [];
        const counts = scanData?.kernel_details?.kernel_counts || {};

        let original = 0;
        let updated = 0;
        deps.forEach((cls) => {
            original += Number(counts[cls]) || 0;
            updated += Number(updatedKarnelCount[cls]) || 0;
        });

        setOverallScore(original);
        setUpdatedOverallScore(updated);
    }, [scanData, updatedKarnelCount]);

    // --- Submit Logic ---
    const onConfirmSubmit = (type) => {
        setSubmitType(type);
        setIsOpenConformationModel(true);


        // const sumCount = Object.values(updatedKarnelCount).reduce(
        //     (s, v) => s + parseFloat(v),
        //     0
        // );
        // const sumWeight = Object.values(updatedKarnelWeight).reduce(
        //     (s, v) => s + parseFloat(v),
        //     0
        // );

        // const equalCount =
        //     Number(total_kernel_count) === Number(sumCount.toFixed(2));
        const equalWeight =
            viewUpdatedValues.updatedKarnelWeightPercentage >= 99.5 &&
            viewUpdatedValues.updatedKarnelWeightPercentage <= 100.5;

        setTitle("Update Json");

        if (type === "count") {
            setMessage("Do you want to Update ?");
        } else if (type === "weight" || type === "both") {
            setMessage(
                equalWeight
                    ? "Do you want to Update ?"
                    : "Weight is not matched !!!"
            );
        }

    };

    const updateModifiedJsonAPI = async () => {
        const details = scanData.kernel_details;
        const sumCount = Object.values(updatedKarnelCount).reduce(
            (s, v) => s + parseFloat(v),
            0
        );

        const sumWeight = Object.values(updatedKarnelWeight).reduce(
            (s, v) => s + parseFloat(v),
            0
        );
        if (submitType === "count" || submitType === "both") {
            details.kernel_counts = updatedKarnelCount;
            details.total_kernel_count = Number(sumCount)
        }
        if (submitType === "weight" || submitType === "both") {
            details.kernel_weights = updatedKarnelWeight;
            details.total_kernel_weight = Number(sumWeight.toFixed(2))
        }

        scanData.result_updated = {
            ...(submitType === "count" && { count_updated: true }),
            ...(submitType === "weight" && { weight_updated: true }),
            ...(submitType === "both" && {
                count_updated: true,
                weight_updated: true,
            }),
        };

        if (message === "Do you want to Update ?") {
            try {
                const res = await updateDeepAnalysis(scan_id, sub_scan_id, scanData);
                if (res?.data?.status === false) {
                    setMessage(res?.data?.message);
                    setIsErrorMessage(true);
                } else {
                    navigate("/deep-analysis");
                }
            } catch (err) {
                console.error("Update API failed:", err);
            }
        }
    };

    // --- UI ---
    if (isLoading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100vh"
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box>
            <header
                style={{
                    padding: 15,
                    textAlign: "start",
                    backgroundColor: "rgb(34, 93, 153)",
                    color: "white",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                <ArrowBackIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/deep-analysis")}
                />
                Deep Analysis - CV
            </header>

            <main>
                <AppMessageModel
                    open={isOpenConformationModel}
                    setOpen={setIsOpenConformationModel}
                    title={title}
                    message={message}
                    onActionButton={updateModifiedJsonAPI}
                />

                <Box display="flex" gap={4} p={2}>
                    {/* Left Panel */}
                    <Box width="70%">
                        {scanData && (
                            <Card sx={{ p: 2, backgroundColor: "#E8F5E9" }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <p>
                                            <b style={{ color: "#b34d00" }}>Scan ID:</b> {scan_id}
                                        </p>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <p>
                                            <b style={{ color: "#b34d00" }}>Sub Scan ID:</b> {sub_scan_id}
                                        </p>
                                    </Grid>

                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <p>
                                            <b style={{ color: "#b34d00" }}>Total Kernal Count: :</b> {scanData?.kernel_details?.total_kernel_count}
                                        </p>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <p>
                                            <b style={{ color: "#b34d00" }}>Manual Total Weight:</b> {scanData?.weight_value}
                                        </p>
                                    </Grid>

                                </Grid>
                            </Card>

                        )}

                        {/* Input + Button */}
                        <Box display="flex" gap={3} mt={3}>
                            
                            <TextField
                                type="text"
                                value={inputValueForCount}
                                onChange={(e) => setInputValueForCount(e.target.value)}
                                placeholder="Enter Count"
                                style={{ width: "300px" }}
                            />
                            <Button variant="contained" onClick={handleOkClickForCount}>
                                OK
                            </Button>
                            <TextField
                                type="text"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                placeholder="Enter Manual Weight Percentage"
                                style={{ width: "300px" }}
                            />
                            <Button variant="contained" onClick={handleOkClick}>
                                OK
                            </Button>
                        </Box>

                        {scanData && (
                            <TableComponent
                                scanResult={scanData}
                                scanID={scan_id}
                                subScanID={sub_scan_id}
                                kernals={scanData?.kernel_details}
                                isEdit={isEdit}
                                setUpdatedKernalCount={setUpdatedKernalCount}
                                setUpdatedKernalWeight={setUpdatedKernalWeight}
                                valuesArray={valuesArray}
                                valuesArrayForCount={valuesArrayForCount}
                                viewUpdatedValues={viewUpdatedValues}
                                setViewUpdatedValues={setViewUpdatedValues}
                            />
                        )}

                        {/* Action Buttons */}
                        <Box display="flex" gap={2} mt={2}>
                            <Button variant="contained" onClick={() => setIsEdit(!isEdit)}>
                                {isEdit ? "Back" : "Update"}
                            </Button>
                            {isEdit && (
                                <>
                                    <Button
                                        variant="contained"
                                        onClick={() => onConfirmSubmit("count")}
                                    >
                                        Submit Count
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => onConfirmSubmit("weight")}
                                    >
                                        Submit Weight
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => onConfirmSubmit("both")}
                                    >
                                        Submit Count & Weight
                                    </Button>
                                </>
                            )}
                        </Box>
                    </Box>

                    {/* Right Panel */}
                    {/* <Box mt={5}>
                        {scanFiles && (
                            <>
                                <ImageZoom src={scanFiles.top} alt="Image" />
                            </>
                        )}
                    </Box> */}
                </Box>
            </main>
        </Box>
    );
}

export default DeepAnalysis;
